function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @namespace source.items.trash
 */
import { toItem } from './mappers/item';
import { toError } from './parsers/error';
import { initItems } from './items';
export function initItemsTrash(settings, http) {
  function mapItemList(res, thumbnailSizes) {
    res.data = (res.data.files || []).map(function (item) {
      var newItem = toItem(item, settings, thumbnailSizes);
      newItem.isInTrash = true;
      return newItem;
    });
    return res;
  }

  var items = initItems(settings, http);
  var defaultPaging = {
    size: 50,
    cursor: null
  };
  var defaultSort = {
    order: 'date',
    direction: 'desc'
  };

  function list(folderId, options) {
    options = options || {};

    var sort = _objectSpread({}, defaultSort, {}, options.sort);

    var paging = _objectSpread({}, defaultPaging, {}, options.paging);

    var queryParams = {
      page_size: paging.size,
      cursor: paging.cursor,
      parent_folder_id: folderId,
      media_type: options.mediaType
    };
    queryParams.order = sort.direction === 'desc' ? "-" + sort.order : sort.order;

    if (settings.namespace) {
      queryParams.ns = settings.namespace;
    }

    return http.get(settings.apiUrl + "/go/site/media/trash/files", queryParams, {
      headers: options.headers || {}
    }).then(function (response) {
      response.paging = {
        size: paging.size,
        cursor: response.data.cursor
      };
      return mapItemList(response, options.thumbnails);
    })["catch"](toError);
  }

  function search(folderId, query, options) {
    return items.search(folderId, query, options).then(function (response) {
      response.data = response.data.map(function (item) {
        item.isInTrash = true;
        return item;
      });
      return response;
    })["catch"](toError);
  }

  return {
    list: list,
    search: search
  };
}